/** * 底部菜单 */
<template>
  <!-- 底部2 -->
  <footer class="footer" id="footer2" style="margin-top:0">
    <div class="footer_bar"></div>

    <div class="footerBorder">
      <div class="footer_bottom">
        <!-- <div class="linkHerf">
          <ul v-for="(item, index) in leftMenu" :key='index'>
            <li>
              <h3>{{ item.categoryName }}</h3>
            </li>
            <li v-for="(titleItem, indexs) in item.helpArticleList" :key="indexs">
              <router-link :to="`siteHelpDetail?itemId=${titleItem.articleId}`">
                <div class="OneLineDisplay" :title="titleItem.articleTitle">{{ titleItem.articleTitle }}</div>
              </router-link>
            </li>
          </ul>
        </div> -->
        <div class="textCenter">
          <p>© Copyright 2021 浙江挪客运动用品股份有限公司 </p>
          <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022013703号-3</a>
        </div>
      </div>
    </div>

    <!-- <div class="footer_menu clearfix">
      <div class="wrap1 clearfix">
        <dl class="itemLink" v-for="(item, index) in leftMenu" :key='index'>
          <dt>{{ item.categoryName }}</dt>
          <dd v-for="(titleItem, indexs) in item.helpArticleList" :key="indexs">
            <p>
              <router-link :to="`siteHelpDetail?itemId=${titleItem.articleId}`">
                <div class="OneLineDisplay" :title="titleItem.articleTitle">{{ titleItem.articleTitle }}的换货单号大户的多好多好 多好多好</div>
              </router-link>
            </p>
          </dd>
        </dl>
      </div>
      <div class="copyright_pc">
        <p>
          {{ informations.copyrightInformation }}
          <br />
          <a :href="informations.icpUrl" target="_blank">{{ informations.icp }}</a>
        </p>
      </div>
    </div> -->
  </footer>
</template>
<script>
  import { menu } from "../api/userMG";
  import { helpArticle_list, article_category_list, copyRight, bottom_article_list } from '@/api/xunyou'
  import {
    CryptoJS,
    SHA256,
    encHex
  } from 'crypto-js'
  export default {
    name: "leftnav",
    data() {
      return {
        collapsed: false,
        allmenu: [],
        leftMenu: [],
        informations: {}
      };
    },
    // 创建完毕状态(里面是操作)
    created() {
      //this.getHelpArticle_list()
      // this.getArticleList()
      // this.geTCopyright()
    },
    methods: {
      // 获取版权名称
      geTCopyright() {
        copyRight().then(res => {
          // console.log(res)
          if (res.code == 0) {
            this.informations = res.rows[0]
            if (this.informations.powstatus == 1) {
              this.$router.push('/erroPage')
            } else {
              this.$store.commit('getcopyRight', this.informations)
            }
          }
        }).catch(err => {
          // this.$message.error(this.$t('login.Query failed, please try again later!'))
          console.log(err);

        })
      },
      // 文章分类列表   
      async getArticleList() {
        try {
          let res = await bottom_article_list()
          // console.log(res);
          // let resText = this.extractArrText(res.rows, 'String').join('\n');
          // console.log(resText);
          // let response = await this.transform(resText, 'en')
          // let transVal = await this.regCheck(res.rows, response.split('\n'),resText.split('\n'))
          // console.log(transVal)
          if (res.code == 0) {
            this.leftMenu = res.rows

          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        } catch (error) {
          this.editFormVisible = false
          this.loading = false
          // this.$message.error(this.$t('login.Failed to fetch list, please try again later!'))
          console.log(error);

        }

      },
      // Extract array text
      // 正则验证 取值
      extractArrText(arr, str) {
        let textArr = []
        let reg = /^(?:[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|[|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff09|\u300a|\u300b|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\uffe5]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0])+$/
        // let reg =  /[\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff09|\u300a|\u300b|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\uffe5]/
        arr.forEach(element => {
          var keys = Object.entries(element);
          for (let i of keys) {
            let value = reg.test(i[1])
            if (value) {
              textArr.push(i[1])
            } else if (Array.isArray(i[1])) {
              i[1].forEach(item => {
                let itemKey = Object.entries(item);
                for (let y of itemKey) {
                  let itemValue = reg.test(y[1])
                  if (itemValue) {
                    textArr.push(y[1])
                  }
                }
              })
            }
          }
        });
        return textArr
      },
      // 正则验证，填充值
      regCheck(newarr, formData, ) {
        console.log(formData);
        let reg = /^(?:[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|[|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff09|\u300a|\u300b|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\uffe5]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0])+$/
        let arr = newarr
        return new Promise((resolve, reject) => {

          // console.log(y);
          for (let p in newarr) {
            // console.log(p);
            let element = newarr[p]
            let valkeys = Object.entries(element);
            console.log(valkeys);
            for (let i of valkeys) {
              let value = reg.test(i[1])

              let key = i[0]
              if (value) {
                console.log(p);
                // arr[p][key] = y
                element[key] = formData[p]

              }
              //  else if (Array.isArray(i[1])) {
              //   for (let index in i[1]) {
              //     let item = i[1][index]
              //     let itemKey = Object.entries(item);
              //     for (let u of itemKey) {
              //       let itemValue = reg.test(u[1])
              //       if (itemValue) {
              //         let ikey = u[0]
              //         element[key][index][ikey] = y
              //       }
              //     }
              //   }
              // }
            }

          }

          resolve(newarr)
        })


        console.log(newarr);
      },






      truncate(q) {
        let len = q.length;
        if (len <= 20) return q;
        return q.substring(0, 10) + len + q.substring(len - 10, len);
      },
      //翻译
      transform(query, language) {
        // console.log(query);
        let appKey = "3b89477f75c4cf69"
        let key = 'KDMMDVNh9dtxMeCmsMRT9Rt4j1Ryvmaa';
        // let query = '数码办';
        let salt = (new Date).getTime();
        let curtime = Math.round(new Date().getTime() / 1000);
        let str1 = appKey + this.truncate(query) + salt + curtime + key;
        let sign = SHA256(str1).toString(encHex);
        return new Promise((resolve, reject) => {
          let params = {
            q: query,
            from: "auto",
            to: language,
            appKey: appKey,
            salt: salt,
            sign: sign,
            signType: "v3",
            curtime: curtime
          }

          this.$jsonp("https://openapi.youdao.com/api", params).then(res => {
            resolve(res.translation[0])
          }).catch(err => {
            console.log(err);
            reject(err)
          })
        })
      },
      // 文章（和公告）列表接口   
      getHelpArticle_list() {
        helpArticle_list()
          .then(res => {
            if (res.code == 0) {
              this.allmenu = res.rows;
              // if(res.rows.length>0){

              // const s = new Set() //实例化对象
              // console.log(s,'封装数据------------')

              // res.rows.forEach(item => s.add(item.categoryId)) //添加值（Set可以去掉重复数据）

              // let newData = Array.from({ length: s.size }, () => []) //创建指定长度数组并添值

              // res.rows.forEach(item => {

              //     let index = [...s].indexOf(item.categoryId) //找到指定下标

              //     newData[index].push(item) //添加数据

              // })
              // this.allmenu = newData
              //   console.log(this.allmenu,'封装数据------------')
              // }
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            // this.loading = false
            // this.$message.error(this.$t('index.Failed to get list of articles, please try again later!'))
            // error
            console.log(err);
          })
      },
    }
  };
</script>
<style scoped lang='less'>
  .footer {
    padding-top: 20px;
  }

  .footerBorder {
    border-top: 3px solid #EA0A2A;
    padding: 20px 0;
    color:#333;
    .footer_bottom {
      width: 1200px;
      margin: 0 auto;
      .linkHerf {
        display: flex;
        padding-bottom:20px;
        ul {
          overflow: hidden;
          flex: 1;
          text-align: left;
          box-sizing: border-box;
          padding-right: 16px;
          padding-left:16px;
          li {
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 22px;
            h3 {
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 6px;
            }
          }
        }
      }
      .textCenter{
        text-align:center;
        font-size:14px;
        /* border-top:1px solid #ddd; */
        /* padding-top:20px; */
      }
    }
  }



  .copyright_pc {
    position: revert;
    text-align: center;
    margin: 10px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/footernav.vue